import { IsArray as _IsArray, IsBoolean as _IsBoolean, IsEmail as _IsEmail, IsNotEmpty as _IsNotEmpty, IsNumber as _IsNumber, IsObject as _IsObject, IsOptional as _IsOptional, IsString as _IsString, Length as _Length, Max as _Max, MaxLength as _MaxLength, Min as _Min, ValidateIf as _ValidateIf } from 'class-validator';
//lookup existing message interpolation patterns in the source:
//https://github.com/typestack/class-validator/blob/develop/src/decorator/number/Max.ts
// '$property should not be empty'
export const IsNotEmpty = (validationOptions) => _IsNotEmpty({
    ...validationOptions,
    message: 'msg-class-validator:isNotEmpty'
});
// '$property must be shorter than or equal to $constraint1 characters'
export const MaxLength = (max, validationOptions) => _MaxLength(max, {
    ...validationOptions,
    message: 'msg-class-validator:maxLength',
    context: { constraint1: max }
});
// '$property must not be less than $constraint1'
export const Min = (minValue, validationOptions) => _Min(minValue, {
    ...validationOptions,
    message: 'msg-class-validator:minValue',
    context: { constraint1: minValue }
});
// '$property must not be greater than $constraint1'
export const Max = (maxValue, validationOptions) => _Max(maxValue, {
    ...validationOptions,
    message: 'msg-class-validator:maxValue',
    context: { constraint1: maxValue }
});
// '$property must be a string'
export const IsString = (validationOptions) => _IsString({ ...validationOptions, message: 'msg-class-validator:isString' });
// '$property must be an email'
export const IsEmail = (options, validationOptions) => _IsEmail(options, {
    ...validationOptions,
    message: 'msg-class-validator:isEmail'
});
// '$property must be a number conforming to the specified constraints'
export const IsNumber = (options, validationOptions) => _IsNumber(options, {
    ...validationOptions,
    message: 'msg-class-validator:isNumber'
});
// '$property must be an object'
export const IsObject = (validationOptions) => _IsObject({ ...validationOptions, message: 'msg-class-validator:isObject' });
// '$property must be a boolean value'
export const IsBoolean = (validationOptions) => _IsBoolean({
    ...validationOptions,
    message: 'msg-class-validator:isBoolean'
});
// '$property must be an array'
export const IsArray = (validationOptions) => _IsArray({ ...validationOptions, message: 'msg-class-validator:isArray' });
export const Length = (min, max, validationOptions) => _Length(min, max, {
    ...validationOptions,
    message: 'msg-class-validator:length',
    context: {
        constraint1: min,
        constraint2: max
    }
});
//
// No message decorators equals to original for only have one true source on this project.
export const IsOptional = _IsOptional;
export const ValidateIf = _ValidateIf;
export const DEFAULT_STRING_MIN = 1;
export const DEFAULT_STRING_MAX = 250; // Close to 255 DB limit
//# sourceMappingURL=classValidatorWrapper.js.map